import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux';
import { useCollection } from '../hooks/useCollection';
import { InputLabel, Select, MenuItem, Box, FormControl } from '@mui/material';
import DigBarChart from './DigBarChart'
// import * as htmlToImage from 'html-to-image';
// import { toPng, toJpeg, toBlob, toPixelData, toSvg } from 'html-to-image';
// import IconButton from '@mui/material/IconButton';
// import { Tooltip } from '@mui/material';
// import PrintIcon from '@mui/icons-material/Print';
// import PdfDocument from './PdfDocument';
// import { setId } from '../context/companySlice';


export default function UserReports() {
  const email = useSelector((state) => state.user.emailId)
  const { data: trainingDays } = useCollection('/TrainingDays/' + email)
  const [tDayId, setTdayId] = useState('')
  const [tDayId2, setTdayId2] = useState('')
  const [filteredTrainingdays, setFilteredTrainingDays] = useState([])
  const [filteredTrainingdays2, setFilteredTrainingDays2] = useState([])
  const [exName1, setExName1] = useState('')
  const [exName2, setExName2] = useState('')

  var uniquePrograms = []
  trainingDays && trainingDays.map(tday => {
    if (!uniquePrograms.find(p => p.ProgramId === tday.ProgramId)) {
      uniquePrograms.push(tday)
    }

    return null
  })

  // reset data when changing users
  useEffect(() => {
    setTdayId('')
    setTdayId2('')
    setExName1('')
    setExName2('')

    setFilteredTrainingDays([])
    setFilteredTrainingDays2([])

  }, [email])

  uniquePrograms.sort((a, b) => {
    const nameA = a.ProgramName.toUpperCase(); // Convert names to uppercase for case-insensitive sorting
    const nameB = b.ProgramName.toUpperCase();

    if (nameA < nameB) {
      return -1;
    }
    if (nameA > nameB) {
      return 1;
    }
    return 0;
  });

  const handleExerciseChange = (event) => {
    const id = event.target.value
    setTdayId(id)
    setFilteredTrainingDays(trainingDays.filter((tday) => tday.ProgramId === id))
    const prog = uniquePrograms.find(tday => tday.ProgramId === id)
    if (prog) {
      setExName1(prog.ProgramName)
    }
  }

  const handleExerciseChange2 = (event) => {
    const id = event.target.value
    setTdayId2(id)
    setFilteredTrainingDays2(trainingDays.filter((tday) => tday.ProgramId === id))
    const prog = uniquePrograms.find(tday => tday.ProgramId === id)
    if (prog) {
      setExName2(prog.ProgramName)
    }
  }

  // const handlePrint = async () => {
  //   setFilteredTrainingDays([])

    // const node = document.getElementById('report-bar-chart')
    // htmlToImage.toPng(node)
    //   .then(function (dataUrl) {
    //     var img = new Image();
    //     img.src = dataUrl;
    //     document.body.appendChild(img);
    //   })
    //   .catch(function (error) {
    //     console.error('oops, something went wrong!', error);
    //   });
  // };


  return (
    <div>
      <Box sx={{ minWidth: 100, padding: 2 }}>
      <span style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            paddingLeft: 20,
                            paddingRight: 20,
                            marginTop: 1
                        }}>
          <FormControl fullWidth size='small'>
            <InputLabel id="demo-simple-select-label">Velg øvelse 1</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={tDayId}
              label="exercise"
              onChange={handleExerciseChange}
            >
              {uniquePrograms && uniquePrograms.map(tday => (
                <MenuItem value={tday.ProgramId}>{tday.ProgramName}</MenuItem>
              ))}
            </Select>
          </FormControl>
          <div style={{width: 20}} />
          <FormControl fullWidth size='small' >
            <InputLabel id="demo-simple-select-label2">Velg øvelse 2</InputLabel>
            <Select
              labelId="demo-simple-select-label2"
              id="demo-simple-select2"
              value={tDayId2}
              label="exercise2"
              onChange={handleExerciseChange2}
          
            >
              {uniquePrograms && uniquePrograms.map(tday => (
                <MenuItem value={tday.ProgramId}>{tday.ProgramName}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </span>
      </Box>
      {/* <Tooltip title="Skriv ut diagram">
        <IconButton
          size="small"
          aria-label="print"
          aria-controls=""
          aria-haspopup="true"
          onClick={handlePrint}
          color="inherit"
        >
          <PrintIcon />
        </IconButton>
      </Tooltip> */}
      {/* <PdfDocument /> */}
      <div style={{ marginTop: 30 }} id='report-bar-chart' >
        <DigBarChart
          data={filteredTrainingdays}
          compareData={filteredTrainingdays2}
          exerciseName1={exName1}
          exerciseName2={exName2}
        />
      </div>
    </div>

  )
}
